export default function StepsSection() {
  const steps = [
    {
      number: '1',
      title: 'LINE で友だち追加',
      description: 'ボタンをタップして、トラストの公式 LINE を友だち追加してください。'
    },
    {
      number: '2',
      title: '希望条件をお聞かせください',
      description: '勤務地、時間、時給など、あなたの希望条件を気軽にメッセージで送ってください。'
    },
    {
      number: '3',
      title: '最適な案件をご提案',
      description: '専任コーディネーターがあなたにぴったりの職場をご提案。職場見学も可能です。'
    }
  ];

  return (
    <section className="py-16 sm:py-20 bg-gradient-to-br from-green-50 to-emerald-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4 sm:mb-6">
            簡単3ステップで始められます
          </h2>
          <p className="text-lg sm:text-xl text-gray-600">
            LINE 登録から就業開始まで、わかりやすくサポートします
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-6 sm:gap-8 mb-8 sm:mb-12">
          {steps.map((step, index) => (
            <div key={index} className="bg-white p-6 sm:p-8 rounded-2xl shadow-lg text-center">
              <div className="w-14 h-14 sm:w-16 sm:h-16 bg-[#06C755] text-white rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6 text-xl sm:text-2xl font-bold">
                {step.number}
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 sm:mb-4">
                {step.title}
              </h3>
              <p className="text-sm sm:text-base text-gray-700">
                {step.description}
              </p>
            </div>
          ))}
        </div>
        <div className="text-center">
          <div className="bg-yellow-100 border border-yellow-300 rounded-2xl p-4 sm:p-6 mb-6 sm:mb-8 inline-block">
            <p className="text-sm sm:text-base text-yellow-800 font-medium">
              🎁 今なら公式LINEから無料登録いただくと「QUOカード500円」をプレゼント!
            </p>
          </div>
          <a 
            href="https://lin.ee/MJ3LVM2" 
            target="_blank"
            rel="noopener noreferrer"
            className="line-btn-primary inline-flex items-center space-x-3 text-lg sm:text-xl font-medium whitespace-nowrap cursor-pointer"
          >
            <div className="w-6 h-6 sm:w-7 sm:h-7 flex items-center justify-center">
              <i className="ri-line-fill text-xl sm:text-2xl"></i>
            </div>
            <span>今すぐ LINE で友だち追加</span>
          </a>
        </div>
      </div>
    </section>
  );
}